import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { useEvents } from "./DanceEventProvider.jsx";
import { useAuth } from "./Auth/AuthPage.jsx";

const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST;

const PopularButton = ({ event }) => {
    const [loading, setLoading] = useState(false);
    const { loadEvents } = useEvents();
    const { user } = useAuth();

    // Only show button if user has calendarAdmin = true
    if (!user || !user.calendarAdmin) {
        return null;
    }

    const handlePopularToggle = async () => {
        if (!event || !event.id) {
            console.error("Event or event ID is missing");
            return;
        }

        setLoading(true);

        try {
            const token = window.localStorage.getItem("authToken");
            const newPopularValue = !event.popular;

            const response = await fetch(`${BACKEND_HOST}/events/${event.documentId}/toggle-popular`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    ...(token && { "Authorization": `Bearer ${token}` })
                },
                body: JSON.stringify({
                    data: {
                        popular: newPopularValue
                    }
                })
            });

            if (!response.ok) {
                throw new Error(`Failed to update event: ${response.statusText}`);
            }

            // Refresh events to get updated data
            loadEvents();

        } catch (error) {
            console.error("Error updating popular status:", error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <Button disabled size="small">
                <CircularProgress size={16} />
            </Button>
        );
    }

    return (
        <Button
            size="small"
            onClick={handlePopularToggle}
            startIcon={event.popular ? <StarIcon /> : <StarBorderIcon />}
            variant={event.popular ? "contained" : "outlined"}
            color="primary"
        >
            {event.popular ? "Popular" : "Mark Popular"}
        </Button>
    );
};

export default PopularButton;